export default function grouper(groups) {
  return Object.keys(groups).reduce((reduced, reducing) => {
    reduced[reducing] = {
      ...groups[reducing],
      key: reducing,
    };

    return reduced;
  }, {});
}
